"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
const SelectCustom = _ref => {
  let {
    isMobile,
    options,
    icon,
    handleOption = 'none',
    currentValue = 'none',
    selectLabel = 'Select',
    placeholder = 'pick your choice',
    menuClassName,
    selectClassName,
    defaultColor,
    dataTestid,
    className,
    textHelperError,
    ...others
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, (0, _extends2.default)({
    variant: "outlined"
  }, others), /*#__PURE__*/_react.default.createElement(_core.FormLabel, {
    className: classes.legend,
    component: "legend"
  }, selectLabel), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(classes.rootSelectCustom, className)
  }, icon, !isMobile && /*#__PURE__*/_react.default.createElement(_core.Select, {
    style: {
      color: defaultColor
    },
    IconComponent: _KeyboardArrowDown.default,
    classes: {
      select: selectClassName
    },
    value: currentValue,
    inputProps: {
      'data-testid': dataTestid
    },
    MenuProps: {
      classes: {
        paper: icon ? (0, _clsx.default)(classes.listBoxWithIcon, menuClassName) : (0, _clsx.default)(classes.listBoxWithOutIcon, menuClassName)
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    onChange: handleOption
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    value: "none",
    disabled: true,
    selected: true
  }, placeholder), options && options.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: value,
      value: value
    }, label);
  })), isMobile && /*#__PURE__*/_react.default.createElement(_core.Select, {
    style: {
      color: defaultColor
    },
    IconComponent: _KeyboardArrowDown.default,
    native: true,
    classes: {
      select: (0, _clsx.default)(classes.select, selectClassName)
    },
    value: currentValue,
    inputProps: {
      'data-testid': dataTestid
    },
    onChange: handleOption
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "none",
    disabled: true,
    defaultValue: true
  }, placeholder), options && options.map(_ref3 => {
    let {
      value,
      label
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    error: textHelperError
  }, textHelperError));
};
var _default = exports.default = SelectCustom;